import React from 'react';
import { useNavigate } from 'react-router-dom';

const PAPER = '#F2EBDC';
const INK = '#1A1A1A';
const MUTED = '#5A5A5A';

export default function LegalPageLayout({ title, lastUpdated, children }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: PAPER,
        color: INK,
        fontFamily: 'Georgia, serif',
        padding: '24px 20px 64px',
      }}
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            color: MUTED,
            fontFamily: 'Georgia, serif',
            fontSize: 14,
            cursor: 'pointer',
            padding: 0,
            marginBottom: 24,
          }}
        >
          ← Back
        </button>
        <h1
          style={{
            fontSize: 28,
            fontWeight: 600,
            marginBottom: 8,
            lineHeight: 1.3,
          }}
        >
          {title}
        </h1>
        <p
          style={{
            color: MUTED,
            fontSize: 14,
            marginBottom: 32,
            fontStyle: 'italic',
          }}
        >
          Last updated: {lastUpdated}
        </p>
        <div
          style={{
            fontSize: 16,
            lineHeight: 1.65,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
